import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.payment').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.payment', {
                abstract: true,
                url: '/payment',
                component: 'contentLayout',
                data: {
                    authorizedRole: 'USER_BO',
                },
            })
            .state('app.payment.list', {
                url: '/list',
                views: {
                    content: {
                        component: 'listPayments',
                    },
                },
                resolve: {
                    keepSearchData: keepSearchData,
                },
            })
            .state('app.payment.details', {
                url: '/{eid}/details',
                views: {
                    content: {
                        component: 'paymentDetails',
                    },
                },
                params: {
                    eid: null,
                },
                resolve: {
                    payment: [
                        '$transition$',
                        'PaymentDA',
                        ($transition$, PaymentDA) =>
                            $transition$.params().eid ? PaymentDA.getPaymentDetails($transition$.params().eid) : null,
                    ],
                },
            });

        keepSearchData.$inject = ['$transition$'];
        function keepSearchData($transition$) {
            return $transition$.from().name === 'app.payment.details';
        }
    }
})();
